import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { EntityCardContent } from "components/common";
import { AllBankIdPaymentList, BankIdPaymentsFooter, BankIdPaymentTodoSelection } from "components/payment";
import { usePaymentService, usePaymentSigningInformationService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, PaymentHelper } from "utils/helpers";

const BankIdPaymentsTodo: React.FC<TodoCardProps> = (props) => {
  const paymentSigningInformationService = usePaymentSigningInformationService();
  const paymentService = usePaymentService();

  const [total, setTotal] = React.useState<number>(0);
  const [selectedTotal, setSelectedTotal] = React.useState<number>(0);
  const [loading, setLoading] = React.useState(false);

  const paymentSigningInformation = props.item.paymentSigningInformation;

  const initialSelectedPayments = {
    incomingInvoices: [],
    receipts: [],
    salaryPayoutFileRows: [],
    manualPayouts: [],
    personSalaryEntries: [],
    wintSalaryEntries: [],
  } as WintSuperkollAPIModel.PaymentSigningInformation;

  const [selectedPayments, setSelectedPayments] =
    React.useState<WintSuperkollAPIModel.PaymentSigningInformation>(initialSelectedPayments);

  React.useEffect(() => {
    paymentSigningInformation && setTotal(PaymentHelper.calculateBankIdTotal(paymentSigningInformation));
  }, [paymentSigningInformation]);

  const selectedPaymentsCount = PaymentHelper.getTotalBankIdPaymentsCount(selectedPayments);
  const allPaymentsCount = paymentSigningInformation
    ? PaymentHelper.getTotalBankIdPaymentsCount(paymentSigningInformation)
    : 0;

  const onPaymentsSelectionChange = (payments: WintSuperkollAPIModel.PaymentSigningInformation) => {
    setSelectedPayments(payments);
    setSelectedTotal(PaymentHelper.calculateBankIdTotal(payments));
  };

  const reloadTodo = (onSuccess?: (paymentSignInfo: WintSuperkollAPIModel.PaymentSigningInformation) => void) => {
    setSelectedPayments(initialSelectedPayments);
    setSelectedTotal(0);
    setLoading(true);
    paymentService
      .getBankIdPayments()
      .then((result) => {
        onSuccess && onSuccess(result);
        props.onActionSuccess();
      })
      .finally(() => setLoading(false));
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={`${LocalizationHelperInstance.getFormattedCurrency(total)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          descriptionHeadingTwo={`${allPaymentsCount} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Due_Date
          )}: ${LocalizationHelperInstance.getFormattedDate(
            paymentSigningInformationService.getDueDate(props.item.paymentSigningInformation)
          )}`}
        />
      }
      todoMainSection={
        <BankIdPaymentTodoSelection
          selectedPaymentsCount={selectedPaymentsCount}
          allPaymentsCount={allPaymentsCount}
          selectedPaymentsTotal={selectedTotal}
        />
      }
      footer={
        <BankIdPaymentsFooter
          selectedPayments={selectedPayments}
          selectedPaymentsCount={selectedPaymentsCount}
          reloadHandler={reloadTodo}
          disableSuccessMessages
        />
      }
      infoViewer={
        <AllBankIdPaymentList
          paymentSigningInformation={paymentSigningInformation}
          onPaymentSelectionsChange={onPaymentsSelectionChange}
          selectedPayments={selectedPayments}
          reloadHandler={reloadTodo}
        />
      }
      loading={loading}
    ></EntityCardContent>
  );
};

export default BankIdPaymentsTodo;
